(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.mobileMenu = this.querySelector('header-drawer');
      this.currentScrollTop = 0;
      this.preventHide = false;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.enableScroll();
    }

    disconnectedCallback() {
      this.disableScroll();
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide || (this.mobileMenu && this.mobileMenu.isOpen && window.innerWidth <= 1160)) {
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventReveal) {
          return;
        }
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    enableScroll() {
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disableScroll() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["influencer-apply"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var form = document.getElementById('influencer-form');
    var success = document.getElementById('influencer-success');
    if (!form) return;

    // Show success if returning from form submission
    if (window.location.hash === '#influencer-apply' && document.referrer.includes(window.location.hostname)) {
      form.style.display = 'none';
      success.classList.add('is-visible');
    }

    // Client-side validation feedback
    form.addEventListener('submit', function(e) {
      var required = form.querySelectorAll('[required]');
      var valid = true;
      required.forEach(function(el) {
        if (!el.value.trim()) {
          el.style.borderColor = '#c62828';
          valid = false;
        } else {
          el.style.borderColor = '';
        }
      });
      if (!valid) {
        e.preventDefault();
      }
    });

    // Clear error state on input
    form.querySelectorAll('.okura-influencer__input, .okura-influencer__textarea, .okura-influencer__select').forEach(function(el) {
      el.addEventListener('input', function() { this.style.borderColor = ''; });
      el.addEventListener('change', function() { this.style.borderColor = ''; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okura-knives-funnel"] && !Shopify.designMode) return;
  try {
    

function oknfSyncProductCta() {

  var price = document.getElementById('okhPrice');

  var compare = document.getElementById('okhCmpPrice');

  document.querySelectorAll('.oknf-final-product').forEach(function(card) {

    if (price) card.querySelector('[data-oknf-current-price]').textContent = price.textContent;

    if (compare) {

      var oldPrice = card.querySelector('[data-oknf-compare-price]');

      oldPrice.textContent = compare.textContent;

      oldPrice.hidden = !compare.textContent.trim() || getComputedStyle(compare).display === 'none';

    }

  });

}

function oknfInitProductCta() {

  oknfSyncProductCta();

  ['okhPrice','okhCmpPrice'].forEach(function(id) {

    var node = document.getElementById(id);

    if (node && !node.dataset.oknfObserved) {

      node.dataset.oknfObserved = 'true';

      new MutationObserver(oknfSyncProductCta).observe(node,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['style','class']});

    }

  });

}

document.addEventListener('okh:prices-updated',oknfSyncProductCta);

document.addEventListener('shopify:section:load',oknfInitProductCta);

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',oknfInitProductCta); else oknfInitProductCta();

document.addEventListener('click',function(event) {

  var link = event.target.closest('[data-oknf-product-cta]');

  if (!link) return;

  var hero = document.querySelector('.okh');

  var target = hero && (hero.querySelector('.okh-bundle') || hero.querySelector('#okhPrice'));

  if (target) {event.preventDefault();target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});}

});



document.addEventListener('click', function(event) {

  var reviewButton = event.target.closest('[data-oknf-review-scroll]');

  if (reviewButton) {

    var reviews = reviewButton.closest('.oknf-reviews').querySelector('.oknf-track');

    var reviewCard = reviews.querySelector('.oknf-review');

    if (reviewCard) reviews.scrollBy({left:(reviewCard.offsetWidth + (parseFloat(getComputedStyle(reviews).gap) || 0)) * Number(reviewButton.dataset.oknfReviewScroll),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});

    return;

  }

  var button = event.target.closest('[data-oknf-scroll]');

  if (!button) return;

  var track = button.closest('.oknf-selection').querySelector('.oknf-track');

  var card = track.querySelector('.oknf-product');

  if (!card) return;

  var gap = parseFloat(getComputedStyle(track).gap) || 0;

  track.scrollBy({left: (card.offsetWidth + gap) * Number(button.dataset.oknfScroll), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});

});


  } catch(e) { console.error(e); }
})();
})();
